export interface Acceptance {
  address: string
  signature: string
  timestamp: number
}

export interface Onboarding {
  dontShowAgain: boolean
}

export interface AccessToken {
  token: string
  expiresAt: number
  refreshToken: string
}

export const initOnboarding: Onboarding = {
  dontShowAgain: false,
}
